import { render } from "./PsLabelCaption2.vue?vue&type=template&id=24e22c8e&ts=true"
import script from "./PsLabelCaption2.vue?vue&type=script&lang=ts"
export * from "./PsLabelCaption2.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__